import Language, { SUPPORTED_LANGUAGES } from "@bimproject/language";
import styled from "styled-components";

import FileUpload from "./FileUpload";
import * as UI from "../../../../../../modules/ui-kit";


const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > button {
        align-self: flex-start;
    }
`;

export default function Media(props) {
    const { brandID, disabled, onChange, value } = props;

    return (
        <Styled>
            {
                value.map(
                    (medium, i) => (
                        <Medium
                            brandID={ brandID }
                            disabled={ disabled }
                            { ...medium }
                            key={ i }
                            onChange={
                                (updatedMedium) => {
                                    if (!updatedMedium) {
                                        onChange(value.filter((m) => m !== medium));
                                    } else {
                                        onChange(value.map((m) => m === medium ? updatedMedium : m));
                                    }
                                }
                            }
                        />
                    )
                )
            }
            <UI.Button
                disabled={ disabled }
                onClick={ () => onChange([...value, { type: "document" }]) }
            >Add media</UI.Button>
        </Styled>
    );
}

const StyledMedium = styled.div`
    background: #7771;
    border: 1px solid #0001;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;

    .horizontal {
        display: flex;
        flex-direction: row;
        gap: 8px;

        & > * {
            flex: auto;
        }
    }

    input:not(:disabled) {
        background: #fff;
    }

    & > button {
        align-self: flex-start;
    }
`;

const ImagePreview = styled.img`
    align-self: flex-start;
    border-radius: 4px;
    max-height: 200px;
    max-width: 100%;
    object-fit: contain;
`;

const IMAGE_URL = /\.(avif|gif|jpe?g|png|svg|webp)(\?|#|$)/i;

function Medium(props) {
    const { brandID, disabled, language, name, onChange, type, url } = props;

    function setType(type) {
        onChange({ language, name, type, url });
    }

    function setName(name) {
        onChange({ language, name, type, url });
    }

    function setLanguage(language) {
        onChange({ language, name, type, url });
    }

    function setURL(url) {
        onChange({ language, name, type, url });
    }

    return (
        <StyledMedium>
            <div className="horizontal">
                <UI.Field>
                    <UI.FieldLabel>Type</UI.FieldLabel>
                    <UI.Select
                        isDisabled={ disabled }
                        onSelect={ setType }
                        options={
                            [
                                { label: "Document", value: "document" },
                                { label: "Image", value: "image" },
                                { label: "Link", value: "link" },
                            ]
                        }
                        value={ type }
                    />
                </UI.Field>
                <UI.Field>
                    <UI.FieldLabel>Name</UI.FieldLabel>
                    <UI.TextInput
                        disabled={ disabled }
                        onChange={ setName }
                        value={ name }
                    />
                </UI.Field>
                <UI.Field>
                    <UI.FieldLabel>Content language</UI.FieldLabel>
                    <UI.Select
                        isDisabled={ disabled }
                        onSelect={ setLanguage }
                        options={
                            [
                                {
                                    label: "content is not localized",
                                    value: undefined,
                                },
                                ...SUPPORTED_LANGUAGES
                                    .sort(Language.compare)
                                    .map(
                                        (language) => (
                                            {
                                                label: (
                                                    <UI.LocaleCard
                                                        subtitle={ Language.fromCode(language).name }
                                                        title={ Language.fromCode(language).nativeName }
                                                    >
                                                        <UI.Flag code={ Language.fromCode(language).countryCode } />
                                                    </UI.LocaleCard>
                                                ),
                                                value: language,
                                            }
                                        )
                                    ),
                            ]
                        }
                        value={ language }
                    />
                </UI.Field>
            </div>
            <FileUpload
                brandID={ brandID }
                disabled={ disabled }
                onChange={ setURL }
            />
            <UI.Field>
                <UI.FieldLabel>URL</UI.FieldLabel>
                <UI.TextInput
                    disabled={ disabled }
                    onChange={ setURL }
                    value={ url }
                />
            </UI.Field>
            {
                url && (type === "image" || IMAGE_URL.test(url)) && (
                    <ImagePreview
                        alt=""
                        src={ url }
                    />
                )
            }
            <UI.Button
                disabled={ disabled }
                onClick={ () => onChange(undefined) }
            >Delete media</UI.Button>
        </StyledMedium>
    );
}
